<template>
  <CCard class="mb-3">
    <CCardHeader>Comparacion por tipo de mensaje</CCardHeader>
    <CCardBody>
      <div class="small text-muted mb-2">Tasas por tipo de mensaje</div>
      <apexchart
        type="bar"
        height="300"
        :options="chartOptions"
        :series="chartSeries"
      />
    </CCardBody>
    <CCardBody class="p-0 border-top">
      <CDataTable
        :items="rows"
        :fields="fields"
        hover
        striped
        small
        fixed
        :items-per-page="10"
        pagination
      >
        <template #message_type_label="{ item }">
          <td>{{ normalizeLabel(item) }}</td>
        </template>
        <template #sent_count="{ item }">
          <td class="text-right">{{ number(item.sent_count) }}</td>
        </template>
        <template #best_slot="{ item }">
          <td class="text-center">{{ item.best_slot || 'N/D' }}</td>
        </template>
        <template #delivery_rate="{ item }">
          <td class="text-center">{{ percent(item.delivery_rate) }}</td>
        </template>
        <template #read_rate="{ item }">
          <td class="text-center">{{ percent(item.read_rate) }}</td>
        </template>
        <template #response_rate="{ item }">
          <td class="text-center">{{ percent(item.response_rate) }}</td>
        </template>
        <template #avg_minutes_to_read="{ item }">
          <td class="text-center">{{ minutes(item.avg_minutes_to_read) }}</td>
        </template>
        <template #avg_minutes_to_response="{ item }">
          <td class="text-center">{{ minutes(item.avg_minutes_to_response) }}</td>
        </template>
        <template #error_rate="{ item }">
          <td class="text-center">{{ percent(item.error_rate) }}</td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import useMessageTypeLabel from '@/composables/useMessageTypeLabel'

const { getMessageTypeLabel } = useMessageTypeLabel()

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields: [
        { key: 'message_type_label', label: 'Tipo' },
        { key: 'sent_count', label: 'Mensajes' },
        { key: 'best_slot', label: 'Mejor horario' },
        { key: 'delivery_rate', label: 'Entrega' },
        { key: 'read_rate', label: 'Lectura' },
        { key: 'response_rate', label: 'Respuesta' },
        { key: 'avg_minutes_to_read', label: 'Tiempo a lectura' },
        { key: 'avg_minutes_to_response', label: 'Tiempo a respuesta' },
        { key: 'error_rate', label: 'Error' },
      ],
    }
  },
  computed: {
    categories() {
      return this.rows.map(function (row) {
        return row.message_type ? getMessageTypeLabel(row.message_type) : (row.message_type_label || 'N/D')
      })
    },
    chartSeries() {
      const self = this
      const asPct = function (key) {
        return self.rows.map(function (row) {
          return Number(row && row[key] ? row[key] : 0) * 100
        })
      }

      return [
        { name: 'Entrega', data: asPct('delivery_rate') },
        { name: 'Lectura', data: asPct('read_rate') },
        { name: 'Respuesta', data: asPct('response_rate') },
      ]
    },
    chartOptions() {
      return {
        chart: {
          toolbar: { show: false },
          foreColor: '#5c5648',
        },
        colors: ['#8EB69B', '#7F95D1', '#C9A66B'],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 4,
            columnWidth: '58%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: this.categories,
        },
        yaxis: {
          max: 100,
          labels: {
            formatter: function (value) {
              return value.toFixed(0) + '%'
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value.toFixed(1) + '%'
            },
          },
        },
        legend: {
          position: 'top',
        },
        grid: {
          borderColor: '#ece7d8',
        },
      }
    },
  },
  methods: {
    normalizeLabel(row) {
      if (row && row.message_type) {
        return getMessageTypeLabel(row.message_type)
      }

      const value = row && row.message_type_label ? row.message_type_label : ''
      if ((value || '').toLowerCase() === 'reminder') {
        return 'Enviar Recordatorios'
      }

      return value || 'N/D'
    },
    number(value) {
      return Number(value || 0).toLocaleString('es-MX')
    },
    percent(value) {
      return `${(Number(value || 0) * 100).toFixed(1)}%`
    },
    minutes(value) {
      if (value === null || value === undefined) {
        return 'N/D'
      }
      return `${Number(value).toFixed(1)} min`
    },
  },
}
</script>
